import { BReactComponent } from 'blocks-cloud/b-react-component';
import { BreadcrumbsContainer } from 'reactApp/ui/BreadcrumbsContainer/BreadcrumbsContainer';

export default function breadcrumbs(): void {
    const node = document.getElementById('react-breadcrumbs');

    if (node) {
        const component = new BReactComponent({
            ReactComponent: BreadcrumbsContainer,
            renderMode: 'append',
        });

        component.renderTo(node);
    }
}
